<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Position Keeping</h5>
                  <h2 class=" card-title"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Analytics</h2>
                </div>
                <div class=" col-sm-6">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='absolute'}"
                           (click)="selectedPage='absolute';selectedAbsoluteTab='Returns'">Absolute</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='relative'}"
                           (click)="selectedPage='relative';selectedRelativeTab='Excess Returns'">Relative</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedPage=='absolute'">
                <!-- Absolute Tables -->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAbsoluteTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab label="Returns"></mat-tab>
                  <mat-tab label="Volatility"></mat-tab>
                  <mat-tab label="Sharpe ratio"></mat-tab>
                  <mat-tab label="Max Drawdown"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Returns bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Returns' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA && benchmarkPRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.returns : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.returns : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.returns : undefined},
                            {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.returns : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Returns bar chart -->

                <!-- Volatility bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Volatility' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA && benchmarkPRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.volatility : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.volatility : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.volatility : undefined},
                            {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.volatility : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Volatility bar chart -->

                <!-- Sharpe ratio bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Sharpe ratio' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA && benchmarkPRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.sharpe_ratio : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.sharpe_ratio : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.sharpe_ratio : undefined},
                            {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.sharpe_ratio : undefined}
                          ]">
                </app-basic-bar-chart>
                <!-- Sharpe ratio bar chart -->

                <!-- Max Drawdown bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Max Drawdown' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA && benchmarkPRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.maximum_drawdown : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.maximum_drawdown : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.maximum_drawdown : undefined},
                            {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.maximum_drawdown : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Max Drawdown bar chart -->
                <!-- Absolute Tables -->
              </div>
              <div *ngIf="selectedPage=='relative'">
                <!-- Relative Tables -->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onRelativeTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab label="Excess Returns"></mat-tab>
                  <mat-tab label="Tracking Error"></mat-tab>
                  <mat-tab label="Information ratio"></mat-tab>
                  <mat-tab label="Max Relative Drawdown"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Excess Returns bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Excess Returns' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.excess_returns : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.excess_returns : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.excess_returns : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Excess Returns bar chart -->

                <!-- Tracking Error bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Tracking Error' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.tracking_error : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.tracking_error : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.tracking_error : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Tracking Error bar chart -->

                <!-- Information ratio bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Information ratio' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.information_ratio : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.information_ratio : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.information_ratio : undefined}
                          ]">
                </app-basic-bar-chart>
                <!-- Information ratio bar chart -->

                <!-- Max. Relative Drawdown bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Max Relative Drawdown' &&
                                              (originalPRA || is_standalone) &&
                                              (protectedPRA || !is_protected) &&
                                              investablePRA"
                                     [catNames]="category_names"
                                     [catFields]="categories"
                                     [series]="[
                            {label: 'original',   values: originalPRA ? originalPRA.maximum_relative_drawdown : undefined},
                            {label: 'investable', values: investablePRA ? investablePRA.maximum_relative_drawdown : undefined},
                            {label: 'protected',  values: protectedPRA ? protectedPRA.maximum_relative_drawdown : undefined}
                          ]" percent>
                </app-basic-bar-chart>
                <!-- Max. Relative Drawdown bar chart -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div *ngIf="selectedPage=='absolute' || selectedPage=='relative'" class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title"><span *ngIf="selectedPage=='absolute'">{{ selectedAbsoluteTab }}</span>
                      <span *ngIf="selectedPage=='relative'">{{ selectedRelativeTab }}</span></h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <div *ngIf="selectedPage=='absolute'">
                  <!-- Returns table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Returns' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of categories">{{ benchmarkPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Returns table -->

                  <!-- Volatility table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Volatility' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of categories">{{ benchmarkPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Volatility table -->

                  <!-- Sharpe ratio table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Sharpe ratio' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of categories">{{ benchmarkPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Sharpe ratio table -->

                  <!-- Max. Drawdown table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Max Drawdown' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of categories">{{ benchmarkPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Max. Drawdown table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
                <div *ngIf="selectedPage=='relative'">
                  <!-- Excess Returns table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Excess Returns' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Excess Returns table -->

                  <!-- Tracking Error table -->
                  <table  id="tableToExport"*ngIf="selectedRelativeTab=='Tracking Error' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Tracking Error table -->

                  <!-- Information ratio table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Information ratio' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Information ratio table -->

                  <!-- Max. Relative Drawdown table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Max Relative Drawdown' && investablePKA" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of categories" scope="col" >{{ catNames[cat] }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of categories">{{ originalPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of categories">{{ investablePRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of categories">{{ protectedPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Max. Relative Drawdown table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
  </div>
</div>
